import { connect } from 'react-redux';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import { withTranslation } from 'react-i18next';

import CardPassages from 'app/components/Children/CardPassages';

import makePassageInstance from './selectPassages';


const EmptyComponent = () => null;

export default compose(
  // setPropTypes({
  //   id: React.PropTypes.number.isRequired,
  //   date: React.PropTypes.string.isRequired,
  //   className: React.PropTypes.string.isRequired,
  // }),

  withTranslation('children'),

  connect(
    () => {
      const selectPassages = makePassageInstance();
      return (state, props) => ({
        ...selectPassages(state, props),
        // Props:
        // items
        // link
        // appString
        // count
        // { count: 0 } -- если не доступно
      });
    }
  ),

  branch(
    props => props.count,
    renderComponent(CardPassages)
  )

)(EmptyComponent);
